import { Component } from '@angular/core';
import { TabComponent, TabsComponent } from '@group24ag/flowkit';

@Component({
  selector: 'app-ui-tabs-button',
  imports: [TabsComponent, TabComponent],
  template: `
    <div class="flex flex-col gap-3">
      <h1 class="heading-title">Tabs</h1>

      <!-- ── Default ───────────────────────────────────────────── -->
      <section class="flex flex-col gap-10">
        <div class="space-y-3">
          <h3 class="text-sm font-medium">Basic</h3>
          <flk-tabs>
            <flk-tab label="Account">
              <div class="space-y-4">
                <div>
                  <p class="text-sm font-medium">Username</p>
                  <p class="text-sm">&#64;johndoe</p>
                </div>
                <div>
                  <p class="text-sm font-medium">Email</p>
                  <p class="text-sm">john&#64;example.com</p>
                </div>
              </div>
            </flk-tab>
            <flk-tab label="Password">
              <div class="space-y-4">
                <div>
                  <p class="text-sm font-medium">Current password</p>
                  <p class="text-sm">••••••••</p>
                </div>
                <div>
                  <p class="text-sm font-medium">Last changed</p>
                  <p class="text-sm">3 months ago</p>
                </div>
              </div>
            </flk-tab>
            <flk-tab label="Notifications">
              <div class="space-y-4">
                <p class="text-sm">Manage your notification preferences.</p>
              </div>
            </flk-tab>
          </flk-tabs>
        </div>

        <!-- ── With disabled tab ─────────────────────────────────── -->
        <div class="space-y-3">
          <h3 class="text-sm font-medium">With disabled tab</h3>
          <flk-tabs>
            <flk-tab label="Overview">
              <p class="text-sm">Welcome to the overview panel.</p>
            </flk-tab>
            <flk-tab label="Analytics" [disabled]="true">
              <p class="text-sm">Analytics content.</p>
            </flk-tab>
            <flk-tab label="Reports">
              <p class="text-sm">View your reports here.</p>
            </flk-tab>
          </flk-tabs>
        </div>

        <!-- ── Default index ─────────────────────────────────────── -->
        <div class="space-y-3">
          <h3 class="text-sm font-medium">Initial selected tab (index 1)</h3>
          <flk-tabs [initialIndex]="1">
            <flk-tab label="General">
              <p class="text-sm">General settings.</p>
            </flk-tab>
            <flk-tab label="Security">
              <p class="text-sm">Security settings open by default.</p>
            </flk-tab>
            <flk-tab label="Billing">
              <p class="text-sm">Billing information.</p>
            </flk-tab>
          </flk-tabs>
        </div>

        <!-- ── Expanded ─────────────────────────────────────── -->
        <div class="w-1/3 space-y-3">
          <h3 class="text-sm font-medium">Use full width</h3>
          <flk-tabs [initialIndex]="1" [expand]="true">
            <flk-tab label="General">
              <p class="text-sm">General settings.</p>
            </flk-tab>
            <flk-tab label="Security">
              <p class="text-sm">Security settings open by default.</p>
            </flk-tab>
            <flk-tab label="Billing">
              <p class="text-sm">Billing information.</p>
            </flk-tab>
          </flk-tabs>
        </div>
      </section>
    </div>
  `,
})
export class UITabsButtonComponent {}
